export interface IPriceList {
    priceListId: string
    insuranceCompanyId?: string
    insuranceCompanyNameEnglish?: string
    insuranceCompanyNameArabic?: string
    providerId?: string
    providerNameEnglish?: string
    providerNameArabic?: string
    effectiveDate?: string
    deleted?: boolean
    createdBy?: string
    createdDate?: string
    lastUpdatedBy?: string
    lastUpdatedDate?: string
    deletedBy?: string
    deletedDate?: string
    priceListServices?: PricelistService[]
    erpPriceListId?: string
}

export interface PricelistService {
    priceListServiceId: string;
    priceListId: string;
    serviceCodeId?: string;
    serviceCode?: string;
    nonStandardCode?: string;
    nonStandardCodeDesc?: string;
    unitPrice?: number;
    factor?: number;
    createdBy?: string;
    createdDate?: string;
    lastupdatedby?: string;
    lastupdateddate?: string;
    serviceTypeId?: string;
    serviceTypeNameEnglish?: string;
    serviceTypeNameArabic?: string;
}
export interface CategoryDropDownModel {
    categoryId: string;
    nameEnglish?: string;
    nameArabic?: string;
    categoryTypeId: string;
    categoryTypeName: string;
}

export const managePriceListConfig = {
    entityName: 'CONFIGURATION.PRICE_LIST.TITLE',
    nonStandardCode: 'CONFIGURATION.PRICE_LIST.NON_STANDARD_CODE',
    nonStandardCodeDesc: 'CONFIGURATION.PRICE_LIST.NON_STANDARD_CODE_DESC',
    unitPrice: 'CONFIGURATION.PRICE_LIST.UNIT_PRICE',
    factor: 'CONFIGURATION.PRICE_LIST.FACTOR',
    grossPrice: 'FORM_FIELD.GROSS_PRICE',
    discountInPercentage: 'FORM_FIELD.DISCOUNT_%',
    subCategory: 'FORM_FIELD.SUB_CATEGORY',
    sbsStandardDescription: 'FORM_FIELD.SBS_STANDARD_DESCRIPTION',
    categoryId: 'CONFIGURATION.MASTER_DATA.CATEGORY.TITLE',
    sbsCodeId: 'FORM_FIELD.SBS_CODE',
    addPriceListService: 'CONFIGURATION.PRICE_LIST.ADD_SERVICE',
    editPriceListService: 'CONFIGURATION.PRICE_LIST.EDIT_SERVICE'
};